module.exports = __webpack_public_path__ + "img/map_1791458178761_43000.2f7e4402.jpg";